import React from 'react';
import { Box, IconButton, Menu, styled } from '@mui/material';
import { MoreVert } from '@mui/icons-material';

const StyledBox = styled(Box)(
    ({ theme: { spacing, palette, typography, shape } }) => ({
        display: 'flex',
        flexDirection: 'column',
        padding: spacing(2),
        gap: spacing(2)
    })
);

export default function ActionList({ row = {}, children }) {
    const [anchorEl, setAnchorEl] = React.useState({});

    const { email: id } = row;

    const handleMenuClick = (name, value) => {
        setAnchorEl((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleClose = (name) => {
        setAnchorEl((prevState) => ({
            ...prevState,
            [name]: null
        }));
    };

    const open = function (name) {
        return Boolean(anchorEl[name]);
    };

    return (
        <Box>
            <IconButton
                id={id}
                aria-controls={open(id) ? id : undefined}
                aria-haspopup='true'
                aria-expanded={open(id) ? 'true' : undefined}
                onClick={(event) => handleMenuClick(id, event.currentTarget)}
            >
                <MoreVert />
            </IconButton>

            <Menu
                id={id}
                anchorEl={anchorEl[id]}
                open={open(id)}
                onClose={() => handleClose(id)}
                MenuListProps={{
                    'aria-labelledby': `basic-button${id}`
                }}
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <StyledBox>                   
                    {children}
                </StyledBox>
            </Menu>
        </Box>
    );
}
